<template>
  <div class="device-component-list" ref="el">
    <div class="search-hd">
      <el-radio-group v-model="type" class="radio-group" @input="getList">
        <el-radio-button :label="item.value" v-for="(item, index) in tabData" :key="index">{{ item.label }}</el-radio-button>
      </el-radio-group>
      <el-button class="refresh" @click="refresh" :disabled="asyncing">
        <i class="icon icon-refresh"></i>
      </el-button>

      <div class="table-page" v-if="pageData.total > 1">
        <el-pagination :page-size="pageData.size" :total="pageData.total" :layout="pageData.layout" :current-page.sync="pageData.page"></el-pagination>
      </div>
    </div>
    <ul class="device-component-list-ul">
      <li class="classify" v-for="(classify, i) in colFilter(data)" :key="i">
        <div class="classify-name">{{ classify.componentName }}</div>
        <ul
          class="component-list"
          :class="{
            status: type === 'status',
            life: type === 'life',
          }"
        >
          <li
            class="component-detail"
            v-for="(item, j) in listFilter(classify.statusList)"
            :key="j"
            :class="{
              error: item.isMalfunction,
              warning: isWarning(item),
            }"
            @click="detail(item)"
          >
            <div class="icon-content">
              <i v-if="showIcon(item)" class="icon icon-warning1"></i>
              <img v-else :src="item.componentIcon" alt="" />
            </div>
            <div class="component-name">{{ item.componentName }}</div>
            <!-- 类型：部件状态 -->
            <template v-if="type === 'status'">
              <div class="device-status">
                <template v-if="item.statusDicGroup && item.statusVal">
                  {{ getDicValue(item.statusDicGroup, item.statusVal) }}
                </template>
                <template v-else-if="item.statusVal">
                  {{
                    item.statusUnit && item.statusUnit.indexOf('℃') > -1
                      ? `${$celsiusToFahrenheit(item.statusVal)} ${item.statusUnit.replace('℃', $formatTempUnit())}`
                      : item.statusVal + (item.statusUnit || '')
                  }}
                </template>
                <template v-else>
                  {{ $t('components_deviceComponentList.wu') }}
                </template>
              </div>
              <div class="device-time">
                {{ item.currentGmtModified }}
              </div>
            </template>
            <template v-else>
              <div class="device-status">
                {{ !item.currentVal ? $t('components_deviceComponentList.wu') : item.currentVal + item.currentUnit }}
              </div>
              <div class="process-content" v-if="item.currentVal && item.maxVal">
                <!-- {{item.currentVal}}--{{item.criticalVal}}--{{item.maxVal}} -->
                <div class="process">
                  <div
                    class="process-bar"
                    :style="getProcessStyle(item)"
                    :class="{ 'normal-val': item.currentVal / item.criticalVal < 1, 'beyond-val': item.currentVal / item.maxVal > 1, 'warn-val': item.currentVal / item.criticalVal > 1 }"
                  ></div>
                </div>
                <div class="critical-val" :class="{ 'beyond-val': item.currentVal / item.maxVal > 1 }" :style="getCriticalValStyle(item)"></div>
              </div>
              <!-- <div class="device-time" >
                {{item.currentGmtModified}}
              </div> -->
            </template>
          </li>
        </ul>
      </li>
    </ul>
    <component-detail-drawer :visible.sync="show" v-if="show" :model="editModel" :bodyNum="bodyNum"></component-detail-drawer>
  </div>
</template>

<script>
import componentDetailDrawer from '@/components/deviceComponentDetailDrawer';
import apis from '@/utils/apis.js';

export default {
  props: {
    bodyNum: [String, Number],
  },
  components: {
    componentDetailDrawer,
  },
  watch: {
    bodyNum: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getList();
        }
      },
    },
  },
  computed: {
    tabData() {
      return [
        {
          label: this.$t('components_deviceComponentList.bu_jian_zhuang_tai'),
          value: 'status',
        },
        {
          label: this.$t('components_deviceComponentList.bu_jian_shou_ming'),
          value: 'life',
        },
      ];
    },
  },
  data() {
    return {
      provide: true,
      show: false,
      data: [],
      editModel: {},
      // status life
      type: 'status',
      pageData: {
        page: 1,
        size: 1,
        total: 1,
        layout: 'prev, pager, next',
      },
      gutter: 10,
      showColNum: 2,
      rowWidth: 315,
      resizeHandler: null,
      asyncing: false,
    };
  },
  mounted() {
    this.tabData[0].label = this.$t('components_deviceComponentList.bu_jian_zhuang_tai');
    this.tabData[1].label = this.$t('components_deviceComponentList.bu_jian_shou_ming');
    this.resizeHandler = this.$debounce(this.initShowColNum, 100);
    window.addEventListener('resize', this.resizeHandler, false);
  },
  methods: {
    listFilter(list) {
      if (this.type === 'life') {
        return list.filter((item) => item.isLifeLimit);
      } else {
        return list.filter((item) => item.hasData);
      }
    },
    showIcon(item) {
      // 部件寿命不展示icon
      return this.type === 'status' && (item.isMalfunction || this.isWarning(item));
    },
    isWarning(item) {
      if (this.type === 'status') {
        return item.isAlert;
      }
      return item.currentVal && item.criticalVal && item.currentVal > item.criticalVal;
    },
    refresh() {
      this.type = 'status';
      this.$postJSON(`${apis.DeviceResumeRefresh}/${this.bodyNum}`).then(() => {
        this.asyncing = true;
        setTimeout(() => {
          this.asyncing = false;
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getList();
        }, 5000);
      });
    },
    colFilter(list) {
      const start = (this.pageData.page - 1) * this.showColNum;
      const end = start + this.showColNum;
      return list.slice(start, end);
    },
    initShowColNum() {
      const width = this.$refs.el.clientWidth;
      const colNum = Math.floor(width / (this.rowWidth + this.gutter));
      this.pageData.page = 1;
      this.pageData.total = Math.ceil(this.data.length / colNum);
      this.showColNum = colNum;
    },
    detail(row) {
      this.editModel = row;
      this.editModel.bodyNum = this.bodyNum;
      this.editModel.isWarning = this.isWarning(row);
      this.show = true;
    },
    getProcess(val1, val2) {
      return (val1 / val2) * 100;
    },
    getProcessStyle(item) {
      return {
        width: `${this.getProcess(item.currentVal, item.maxVal)}%`,
      };
    },
    getCriticalValStyle(item) {
      return {
        left: `${this.getProcess(item.criticalVal, item.maxVal)}%`,
      };
    },
    getList() {
      this.$getJSON(apis.DeviceResumeComponentList, {
        bodyNum: this.bodyNum,
        // bodyNum: '20200509006'
      }).then((res) => {
        this.data = res.data;
        this.initShowColNum();
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler, false);
  },
};
</script>

<style lang="scss">
.device-component-list {
  .search-hd {
    margin-top: 8px;
    .table-page {
      padding-top: 0;
    }
  }

  .refresh {
    float: right;
    min-width: 32px;
    color: #0d9ae0;
    padding: 0;
  }
  .radio-group {
    float: left;
  }
  .table-page {
    float: right;
  }
  .device-component-list-ul {
    display: flex;
    justify-content: space-between;
    margin-top: 2px;
  }
  .classify {
    width: 315px;
    flex: 1;
    &:nth-child(n + 2) {
      margin-left: 16px;
    }

    .classify-name {
      width: 100%;
      height: 40px;
      line-height: 38px;
      background: #f8f9fb;
      border: 1px solid #f2f3fb;
      text-align: center;
      color: #394668;
      font-size: 12px;
      font-weight: bold;
    }
    .component-list {
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      &.status {
        .component-detail {
          &.error {
            border: 1px solid rgba(255, 92, 91, 0.3);
            background: rgba(255, 247, 247, 1);
            &:hover {
              background: #fff;
            }
            .icon {
              color: #ff5c5b;
            }
          }
          &.warning {
            border: 1px solid rgba(249, 200, 81, 0.3);
            background: rgba(254, 252, 246, 1);
            &:hover {
              background: #fff;
            }
            .process-bar {
              // background: #f36704 !important;
            }
            .beyond-val {
              background-color: #ff0100 !important;
            }

            .icon {
              color: #f9c851;
            }
          }
        }
      }

      &.life {
        .component-detail {
          &.warning {
            .process-bar {
              // background: #f36704 !important;
            }
            .critical-val {
              background: #f36704;
            }
            .beyond-val {
              background-color: #ff0100 !important;
            }
          }
        }
      }

      .component-detail {
        width: calc(50% - 4px);
        height: 100px;
        position: relative;
        padding: 12px 10px 0 12px;
        background: #f8f9fb;
        border: 1px solid #f2f3fb;
        margin-top: 8px;
        flex-shrink: 0;
        border-radius: 2px;
        transition: all 0.3s;
        &:hover {
          cursor: pointer;
          border-color: rgba(13, 154, 224, 0.3);
          background-color: #fff;
        }
        .component-name {
          $h: 18px;
          height: $h;
          line-height: $h;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
        }
        // .using-time {
        //   $h: 24px;
        //   color: #394668;
        //   font-weight: bold;
        //   font-size: 20px;
        //   line-height: $h;
        //   height: $h;
        // }
        .process-content {
          overflow: hidden;
          position: relative;
          padding-bottom: 2px;
        }
        .process {
          position: relative;
          height: 2px;
          width: 100%;
          background: #f0f2f5;
          border-radius: 1px;
          overflow: hidden;
          margin-top: 4px;
          .process-bar {
            position: absolute;
            height: 100%;
            background: #0d9ae0;
            border-radius: 1px;
          }
          .caveat-val {
            background: #0d9ae0 !important;
          }
          .warn-val {
            background: #f36704 !important;
          }
          .beyond-val {
            background-color: #ff0100 !important;
          }
        }
        .critical-val {
          width: 2px;
          height: 4px;
          position: absolute;
          top: 3px;
          background: #f36704;
          transform: translateX(-1px);
        }
        .beyond-val {
          background-color: #ff0100 !important;
        }
        .service-life {
          color: #98a6ad;
          font-size: 12px;
          line-height: 20px;
          margin-top: 8px;
          float: left;
        }
        &:hover {
          .detail {
            opacity: 1;
          }
        }
        .detail {
          color: #35b8e0;
          font-size: 12px;
          float: right;
          line-height: 20px;
          position: absolute;
          right: 14px;
          bottom: 8px;
          opacity: 0;
          transition: all 0.3s;
          &:hover {
            cursor: pointer;
          }
        }
        .icon-content {
          width: 24px;
          height: 24px;
          position: absolute;
          right: 10px;
          top: 10px;
          .icon {
            font-size: 24px;
          }

          > img {
            max-width: 100%;
            max-height: 100%;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            position: absolute;
            margin: auto;
          }
        }

        .device-status {
          color: #6c757d;
          font-size: 12px;
          margin-top: 12px;
          line-height: 18px;
        }
        .device-time {
          color: #98a6ad;
          line-height: 12px;
          height: 12px;
          margin-top: 10px;
          font-size: 12px;
        }
        .date {
          color: #98a6ad;
          font-size: 12px;
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
